import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { authApi } from '../..'
import {
  GetOrganizationSettingsRequest,
  GetOrganizationSettingsResponse
} from './getOrganizationSettings.types'

export const getOrganizationSettings = async (
  request: GetOrganizationSettingsRequest
) => {
  const response = await authApi.get<GetOrganizationSettingsResponse>(
    '/api/settings',
    { params: { module: request.module } }
  )
  return response.data
}

export const GET_ORGANIZATION_SETTINGS_QUERY_KEY = 'getOrganizationSettings'

export const useGetOrganizationSettingsQuery = (
  request: GetOrganizationSettingsRequest,
  options?: ExtendableQueryOptions<GetOrganizationSettingsResponse>
) => {
  return useQuery({
    queryKey: [GET_ORGANIZATION_SETTINGS_QUERY_KEY, request.module],
    queryFn: () => getOrganizationSettings(request),
    ...options
  })
}
